function findData(arrayData, send, field) {
  let d;
  for (let i = 0; i < arrayData.length; i++) {
    if (arrayData[i][field] === send) {
      d = arrayData[i];
      break;
    }
  }
  return d;
}
const filterItems = (query, data, title, limit) => {
  const d = data
    .filter(el => {
      let texto = "";
      title.forEach(function(k) {
        texto += el[k.cod];
      });
      if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        return el;
      }
    })
    .sort((a, b) => {
      return a.codigo < b.codigo ? -1 : 1;
    });
  if (limit) {
    d.slice(0, limit);
  }
  return d;
};

const order = (orderArray, key) => {
  if (orderArray) {
    orderArray.sort((a, b) => {
      return a[key] < b[key] ? -1 : 1;
    });
    return orderArray;
  } else {
    return [];
  }
};

const order1 = (orderArray, key) => {
  if (orderArray) {
    orderArray.sort((a, b) => {
      return a[key] > b[key] ? -1 : 1;
    });
    return orderArray;
  } else {
    return [];
  }
};

const mes = periodo => {
  const mes = parseInt(periodo.substr(4, 2));
  return mes;
};

const year = periodo => {
  var year = parseInt(periodo.substr(0, 4));
  return year;
};

const grupo = codigo => {
  return codigo.substr(0, 1);
};

const sgrupo = codigo => {
  return codigo.substr(0, 2);
};

const scuenta = codigo => {
  return codigo.substr(0, 4);
};
const formatNumber = (v, d) => {
  if (d === 0) {
    v = parseInt(v);
  } else {
    v = parseFloat(v);
  }
  if (isNaN(v)) {
    v = 0;
  }
  v = v.toFixed(d);
  const formatter = new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: d
  });
  return formatter.format(v);
};

const dosDecimales = v => {
  if (!v) {
    return 0;
  }
  if (isNaN(parseFloat(v))) {
    return 0;
  }
  let returned = Math.round(v * 100);
  returned = (returned * 10) / 1000;
  return returned;
};

const formatDate = date => {
  if (date) {
    let formatdate = new Date(date);
    let mes = formatdate.getMonth() + 1;
    let dia = formatdate.getDate();
    const year = formatdate.getFullYear();
    if (dia < 10) {
      dia = `0${dia}`;
    }
    if (mes < 10) {
      mes = `0${mes}`;
    }
    return `${year}-${mes}-${dia}`;
  }
};

export default {
  findData,
  filterItems,
  mes,
  year,
  formatNumber,
  grupo,
  sgrupo,
  scuenta,
  order,
  order1,
  formatDate,
  dosDecimales
};



// WEBPACK FOOTER //
// ./src/helpers/functions.js